/* Nuvō collection-circle transition, departure half (Nov 1 2026): a cream curtain. The arrival half and the styles
   are inline in sections/nuvo-brand-styles.liquid. A click on a home category circle raises a cream panel from the
   bottom, the collection's name settles in the middle with a bronze rule, then the collection opens and the panel
   rises away there. Only transform and opacity animate, so it stays smooth on phones. */
(() => {
  const SEL = 'a.nhs-cat';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* fetch the collection page while the pointer is on its way */
  const warmed = new Set();
  const warm = (a) => {
    if (warmed.has(a.href)) return;
    warmed.add(a.href);
    const l = document.createElement('link');
    l.rel = 'prefetch'; l.href = a.href;
    document.head.appendChild(l);
  };
  document.addEventListener('pointerover', (e) => { const a = e.target.closest && e.target.closest(SEL); if (a) warm(a); });
  document.addEventListener('touchstart', (e) => { const a = e.target.closest && e.target.closest(SEL); if (a) warm(a); }, { passive: true });

  let busy = false;
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest(SEL);
    if (!a || busy || reduce || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!window.Element.prototype.animate) return;
    e.preventDefault();
    busy = true;

    const label = (a.querySelector('.nhs-cat__label') || a).textContent.trim();
    const o = document.createElement('div');
    o.className = 'nvcc';
    o.innerHTML = '<div class="nvcc__panel"></div><div class="nvcc__cap"><span class="nvcc__eyebrow">Collection</span><span class="nvcc__name"></span><span class="nvcc__rule"></span></div>';
    o.querySelector('.nvcc__name').textContent = label;
    document.body.appendChild(o);

    const ease = 'cubic-bezier(.76, 0, .24, 1)';
    o.querySelector('.nvcc__panel').animate([{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], { duration: 480, easing: ease, fill: 'both' });
    o.querySelector('.nvcc__cap').animate([{ opacity: 0, transform: 'translateY(-10%)' }, { opacity: 1, transform: 'translateY(-50%)' }], { duration: 380, delay: 240, easing: 'cubic-bezier(.16, 1, .3, 1)', fill: 'both' });
    o.querySelector('.nvcc__rule').animate([{ width: '0px' }, { width: 'min(160px, 36vw)' }], { duration: 400, delay: 300, easing: 'cubic-bezier(.16, 1, .3, 1)', fill: 'both' });

    let path = '/';
    try { path = new URL(a.href).pathname; } catch (err) {}
    try { sessionStorage.setItem('nuvo-cat', JSON.stringify({ t: Date.now(), label, path })); } catch (err) {}
    setTimeout(() => { location.href = a.href; }, 700);

    /* coming back with the browser's back button: put the home page back as it was */
    const reset = (ev) => { if (!ev.persisted) return; o.remove(); busy = false; window.removeEventListener('pageshow', reset); };
    window.addEventListener('pageshow', reset);
  });
})();
